var map = {
	"./0001.png": 799,
	"./0002.png": 800,
	"./0003.png": 801,
	"./0004.png": 802,
	"./0005.png": 803,
	"./0006.png": 804,
	"./0007.png": 805,
	"./0008.png": 806,
	"./0009.png": 807,
	"./0010.png": 808,
	"./0011.png": 809,
	"./0012.png": 810,
	"./0013.png": 811,
	"./0014.png": 812,
	"./0015.png": 813,
	"./0016.png": 814,
	"./0017.png": 815,
	"./0018.png": 816,
	"./0019.png": 817,
	"./0020.png": 818,
	"./0021.png": 819,
	"./0022.png": 820,
	"./0023.png": 821,
	"./0024.png": 822,
	"./0025.png": 823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 798;